import {
    getOrders,
    addOrUpdateOrder,
    getOrderDetail,
    getOrderHeader,
    submitOrder,
    unSubmitOrder
} from "api/orderApi";

import {
    ORDERS_LOADING,
    FETCH_ORDERS,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDER_HEADER_SUCCESS,
    FETCH_ORDER_DETAIL_SUCCESS,
    SUBMIT_ORDER,
    SUBMIT_ORDER_SUCCESS,
    ADD_OR_UPDATE_ORDER,
    ADD_OR_UPDATE_ORDER_SUCCESS,
    UN_SUBMIT_ORDER_SUCCESS,
    UN_SUBMIT_ORDER
} from "./types";

import defaultErrorHandler from "../api/global/default-error-handler";

export const setOrderLoading = (status) => ({
    type: ORDERS_LOADING,
    payload: status
});

export const fetchOrders = (data) => dispatch => {
    dispatch(setOrderLoading(true));
    getOrders(data)
        .then(response => {
            dispatch({type: FETCH_ORDERS_SUCCESS, payload: response.data});
        })
        .catch(() => {
            dispatch(setOrderLoading(false));
            dispatch(defaultErrorHandler({message: "Could not fetch orders."}, FETCH_ORDERS));
        });
};

export const emptyOrder = () => ({
    type: FETCH_ORDERS_SUCCESS,
    payload: {
        payload: [],
        orderOptions: {}
    }
});

export const fetchOrderDetail = (orderId) => dispatch => {
    dispatch(setOrderLoading(true));
    getOrderDetail(orderId)
        .then(response => {
            dispatch({ type: FETCH_ORDER_DETAIL_SUCCESS, payload: response.data });
        })
        .catch(() => {
            dispatch(setOrderLoading(false));
        });
};

export const fetchOrderHeader = (serviceId) => dispatch => {
    dispatch(setOrderLoading(true));
    getOrderHeader(serviceId)
        .then(response => {
            const { data } = response;

            dispatch({ type: FETCH_ORDER_HEADER_SUCCESS, payload: data });

            if (data.planogramId) {
                dispatch(fetchOrderDetail(data.orderId));
            }
            dispatch(setOrderLoading(false));
        })
        .catch(() => {
            dispatch(setOrderLoading(false));
        });
};

export const submit = (data) => async dispatch => {
    dispatch(setOrderLoading(true));
    submitOrder(data)
        .then(() => {
            dispatch({ type: SUBMIT_ORDER_SUCCESS, payload: true });
            dispatch(fetchOrderHeader(data.serviceId));
            dispatch(fetchOrderDetail(data.orderId));
            // toast("Order submitted successfully", {
            //     type: toast.TYPE.SUCCESS,
            // });
        })
        .catch(() => {
            dispatch(setOrderLoading(false));
            dispatch(defaultErrorHandler({ message: "Could not submit order." },
                SUBMIT_ORDER, false));
        });
};

export const unSubmit = (orderId, serviceId) => async dispatch => {
    dispatch(setOrderLoading(true));
    unSubmitOrder(orderId)
        .then(() => {
            dispatch({ type: UN_SUBMIT_ORDER_SUCCESS, payload: false });
            dispatch(fetchOrderHeader(serviceId));
        })
        .catch(() => {
            dispatch(setOrderLoading(false));
            dispatch(defaultErrorHandler({ message: "Could not unsubmit order." }, UN_SUBMIT_ORDER, false));
        });
};

export const createOrUpdate = (data) => async dispatch => {
    dispatch(setOrderLoading(true));
    addOrUpdateOrder(data)
        .then(response => {
            dispatch({ type: ADD_OR_UPDATE_ORDER_SUCCESS, payload: response.data });
            // dispatch(fetchOrderDetail(data.orderId || response.data.orderId));
            dispatch(fetchOrderHeader(data.serviceId));
            // toast("UPC scanned successfully", {
            //     type: toast.TYPE.SUCCESS,
            // });
        })
        .catch((error) => {
            dispatch(setOrderLoading(false));
            dispatch(defaultErrorHandler({
                    message: typeof error.response !== "undefined" ? error.response.data : "Network error"
                },
                ADD_OR_UPDATE_ORDER, false));
        });
};
